"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountAlert = exports.Alert = void 0;
var luxon_1 = require("luxon");
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var styles = __importStar(require("./Alert.css"));
var Alert = function (_a) {
    var cancelAt = _a.cancelAt;
    if (!cancelAt) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    var formattedCancelAt = luxon_1.DateTime.fromISO(cancelAt).toFormat("LLL dd, yyyy");
    return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "s", className: styles.alert },
        react_1.default.createElement(icons_1.InformationCircle, { color: "caution", className: styles.alertIcon }),
        react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", align: "left", className: styles.alertLabel },
            "Your subscription has been cancelled and your access to Qwilr will end on ",
            formattedCancelAt,
            ".")));
};
exports.Alert = Alert;
var mountAlert = function (mountReactComponent, props) {
    return mountReactComponent(react_1.default.createElement(exports.Alert, __assign({}, props)));
};
exports.mountAlert = mountAlert;
